import React from 'react';
import {Button} from 'react-bootstrap';
import {Cell} from 'fixed-data-table';

export const PermissionEditCell = ({rowIndex, onClick, sortedData, ...props}) => (
  <Cell {...props}>
    <Button
      style={{
        float: 'right',
        padding: 6,
        marginRight: 7,
        marginBottom: 8
      }}
      onClick={(e) => {
        onClick(e, rowIndex, sortedData);
      }}>
      
      編輯權限
    </Button>
  </Cell>
);

export const UserImgCell = ({rowIndex, columnKey, sortedData, ...props}) => (
  <Cell {...props}>
    <img
      alt="userImg"
      style={{
        width: 84,
        height: 84
      }}
      src={sortedData.getObjectAt(rowIndex)[columnKey] || '/imgs/default-profile.png'} />
  </Cell>
);

export const ColorCell = ({rowIndex, columnKey, sortedData, ...props}) => (
  <Cell {...props}>
    <div
      style={{
        float: 'left', width: 34, height: 34,
        marginTop: -8,
        backgroundColor: sortedData.getObjectAt(rowIndex)[columnKey]
      }}>

    </div>
    <div
      style={{
        float: 'left',
        marginTop: -8,
        paddingLeft: 8,
        width: 34, height: 34,
        lineHeight: '34px'
      }}>

      {sortedData.getObjectAt(rowIndex)[columnKey]}
    </div>
  </Cell>
);


// WEBPACK FOOTER //
// ./src/salesky/routes/newAdmin/CustCells.jsx